import { Checkbox, Form } from "antd";
import { useImperativeHandle } from "react";
import Button from "@/common/elements/Button";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";

const CashAccountDetailForm = ({ purchaseFormRef }) => {
  const [form] = Form.useForm();

  // Expose the form methods to parent
  useImperativeHandle(purchaseFormRef, () => ({
    submitForm: () => form.submit(),
    resetForm: () => form.resetFields(),
    getFormValues: () => form.getFieldsValue(),
    setFormValue: () => form.setFieldValue(),
    getFieldsError: () => form.getFieldsError(),
    isFieldsValidating: () => form.isFieldsValidating(),
    validateFields: () => form.validateFields(),
  }));
  return (
    <>
      <Form form={form}>
        <StyledSectionHeading>
          <span>
            Please enter the amount of the withdrawal from the account:
          </span>
        </StyledSectionHeading>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={8}>
            <FormItem
              label="Amount"
              name="amount"
              rules={[
                {
                  required: true,
                  message: "Amount is required",
                },
              ]}
            >
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={8}>
            <FormItem label="Check #" name="checkNumber">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={8}>
            <FormItem
              label="Category"
              name="Category"
              rules={[
                {
                  required: true,
                  message: "Category is required",
                },
              ]}
            >
              <Select options={getOptionsFromRefList("DepositType")} />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={24}>
            <FormItem label="Transaction Details" name="transactionDetails">
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};
export default CashAccountDetailForm;
